import {get, post, put, _delete} from './Tools';

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}formulas_globales/${id}`);
  return response;
};
const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}formulas_globales`);
  return response;
};

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}formulas_globales`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}formulas_globales`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}formulas_globales/${id}`);
  return response;
};

const getFormulasGlobales = async () => {
try{
 const response = await get(`${process.env.REACT_APP_SERVER}formulas_globales/tipos_formulas`);
  return response;
  } catch (error) {
    console.error('Error:', error);
  }
}

export { getAll, getById, insert, update, drop, getFormulasGlobales};
